import { html, View } from 'rune-ts';
import klass from './TermsModal.module.scss';
import { createAgreeModal } from '../../../../../../../services/MarppleShop/shared/client/agreeModal';

class ThirdPartyConsentTerms extends View {
  override template() {
    return html`
      <div class="${klass.root}">
        <section>
          <p>
            ※ 개인정보 수집 및 이용동의는 개인정보의 수집 및 이용목적, 수집항목 및 수집방법 개인정보의 보유 및
            이용기간으로 별도 구분하여 표시됩니다.
          </p>
        </section>
        <section>
          <table class="${klass.terms_table}">
            <thead>
              <tr>
                <th>개인정보의 수집 및 이용목적</th>
                <th>수집항목 및 수집방법</th>
                <th>개인정보의 보유 및 이용 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>1) 전자금융거래서비스 제공에 관한 결제 정보 등 개인정보 수집</div>
                  <ul>
                    <li>- 이용자가 구매한 재화나 용역의 결제 및 현금영수증 발행</li>
                    <li>
                      - 결제 과정 중 본인 식별, 인증, 실명확인 및 이용자가 결제한 거래의 내역을 요청하는 경우
                      응대 및 확인
                    </li>
                    <li>- 이용자가 결제한 거래의 취소 또는 환불, 상품 배송 등 전자상거래 관련 서비스 제공</li>
                    <li>- 이용자가 결제한 대금의 정구 및 수납</li>
                    <li>
                      - 전자금융거래 및 통신 과금 서비스 이용 불가능한 이용자(미성년자 등)와 불량, 불법
                      이용자의 부정 이용 방지
                    </li>
                    <li>- 서비스 제공 및 관련 업무 처리에 필요한 동의 또는 철회 등 의사확인</li>
                    <li>- 회사가 제공하는 결제 알림 메일 발송</li>
                    <li>- 고객 불만 및 민원처리</li>
                    <li>- 이용자의 데이터 오더 결제</li>
                  </ul>
                </td>
                <td rowspan="2">
                  <div>1) 수집항목</div>
                  <div>가. 전자금융거래서비스 이용과 관련된 정보</div>
                  <ul>
                    <li>- 이용자의 생년월일 및 성별</li>
                    <li>
                      - 이용자의 신용카드 정보(카드번호, 유효기간, 생년월일, 비밀번호 앞 2자리) 또는 금융기관
                      계좌 정보(계좌번호, 계좌비밀번호, 예금주명)
                    </li>
                    <li>- 이용자의 휴대폰 또는 유선 전화번호 및 가상 등신사</li>
                    <li>- 이용자의 상품권 번호 및 상품권 제공사의 회원 아이디, 비밀번호</li>
                    <li>- 이용자의 포인트 카드 정보</li>
                    <li>- 전자지갑 휴대폰번호 등 결제 정보</li>
                    <li>- 접속 IP</li>
                    <li>- 이메일</li>
                    <li>- 상품 또는 용역 거래 정보</li>
                  </ul>
                </td>
                <td rowspan="2">
                  <div>
                    이용자의 개인정보는 원칙적으로 수집 및 이용 목적이 달성되면 지체 없이 파기. 단, 아래와
                    같은 경우 관련 법령에 의해 보존.
                  </div>
                  <ul>
                    <li>
                      <span>건당 1만원 초과 전자금융거래에 관한 기록</span><br />
                      <span>- 보존 이유: 전자금융거래법</span><br />
                      <span>- 보존 기간: 5년</span>
                    </li>
                    <li>
                      <span>건당 1만원 이하 전자금융거래에 관한 기록</span><br />
                      <span>- 보존 이유: 전자금융거래법</span><br />
                      <span>- 보존 기간: 1년</span>
                    </li>
                    <li>
                      <span>계약 또는 청약 철회 등에 관한 기록</span><br />
                      <span>- 보존 이유: 전자상거래법</span><br />
                      <span>- 보존 기간: 5년</span>
                    </li>
                    <li>
                      <span>대금결제 및 재화 등의 공급에 관한 기록</span><br />
                      <span>- 보존 이유: 전자상거래법</span><br />
                      <span>- 보존 기간: 5년</span>
                    </li>
                    <li>
                      <span>소비자의 불만 또는 분쟁 처리에 관한 기록</span><br />
                      <span>- 보존 이유: 전자상거래법</span><br />
                      <span>- 보존 기간: 3년</span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <div>2) 신규 서비스 개발 활용 및 인구학적 특성에 따른 통계자료로 활용</div>
                  <ul>
                    <li>- 이용 빈도 파악 및 통계학적 특성에 따른 서비스 제공</li>
                    <li>- 신규 서비스 개발 및 통계학적 특성 분석</li>
                    <li>- 서비스의 유효성 확인, 접속 빈도 파악, 회원의 서비스 이용에 대한 통계자료 활용</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <p>
            이용자의 개인정보의 수집 및 이용 거부이용자는 회사의 개인정보 수집 및 이용동의를 거부할 수
            있습니다. 단, 동의를 거부 하는 경우 서비스 결제가 정상적으로 완료될 수 없음을 알려드립니다.
          </p>
        </section>
      </div>
    `;
  }
}

export const createOnClickThirdPartyConsent = (parent_selector?: string) =>
  createAgreeModal({
    title: '개인정보의 수집 및 이용안내',
    body: new ThirdPartyConsentTerms({}),
    body_klass: `${ThirdPartyConsentTerms}`,
    style_klass: 'terms_modal_style terms_style',
    is_bottom_sheet: false,
    parent_selector,
  });
